import { StyleSheet, Font } from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fBBc9.ttf",
      fontWeight: 300,
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf",
      fontWeight: 400,
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfBBc9.ttf",
      fontWeight: 500,
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlvAw.ttf",
      fontWeight: 700,
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtvBBc9.ttf",
      fontWeight: 900,
    },
  ],
});
Font.register({
  family: 'Lato',
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf',
      fontWeight: 400,
    },
    {
      src: 'https://fonts.gstatic.com/s/lato/v16/S6u9w4BMUTPHh6UVSwiPHA.ttf',
      fontWeight: 700,
    },
    {
      src: 'https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf',
      fontStyle: 'italic',
      fontWeight: 400,
    },
    {
      src: 'https://fonts.gstatic.com/s/lato/v16/S6u9w4BMUTPHh6UVSwiPHA.ttf',
      fontStyle: 'italic',
      fontWeight: 700,
    },
  ],
});
Font.register({
  family: "Lato",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf",
      fontWeight: 400,
    },
    {
      src: "https://fonts.gstatic.com/s/lato/v16/S6u9w4BMUTPHh6UVSwiPHA.ttf",
      fontWeight: 700,
    },
    {
      src: "https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf",
      fontStyle: "italic",
      fontWeight: 400,
    },
    {
      src: "https://fonts.gstatic.com/s/lato/v16/S6u9w4BMUTPHh6UVSwiPHA.ttf",
      fontStyle: "italic",
      fontWeight: 700,
    },
  ],
});

Font.register({
  family: "NotoSans",
  src: "https://fonts.gstatic.com/s/notosans/v27/o-0IIpQlx3QUlC5A4PNb4g.ttf",
});
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "white",
    padding: 10,
  },

  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    fontFamily: "Roboto",
    marginTop: 15,
  },

  logoImage: {
    width: 120,
    height: 30,
    objectFit: "contain",
    marginBottom: 5,
  },
  dietLogoImage: {
    width: 150,
    height: 50,
    objectFit: "contain",
    marginBottom: 10,
  },

  qr: {
    width: 120,
    height: 120,
    objectFit: "contain",
    marginBottom: 5,
  },

  signature: {
    width: 120,
    height: 120,
    objectFit: "contain",
  },

  company: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: 12,
    marginBottom: 0,
    paddingLeft: 6,
  },

  address: {
    width: 300,
  },

  title: {
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700,
    color: "#057AC1",
  },

  mainHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  headerRow: {
    flexDirection: "row",
    backgroundColor: "#057AC1",
    padding: 3,
    paddingLeft: 6,
    marginBottom: 3,
    color: "white",
  },

  headerContent: {
    flexDirection: "row",
    width: "100%",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginBottom: 15,
  },

  text: {
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: 500,
  },

  dataRow: {
    flexDirection: "row",
  },

  invoice: {
    width: 120,
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: 500,
  },

  date: {
    width: 120,
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: 500,
  },

  terms: {
    width: 120,
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: 500,
  },

  termSig: {
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    position: "absolute",
    bottom: -30,
    marginTop: 15,
  },

  termText: {
    flexDirection: "row",
    marginBottom: 5,
    minWidth: "50%",
  },

  termsText1: {
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 500,
    padding: 5,
    minWidth: "10%",
  },

  termsText2: {
    fontFamily: "Roboto",
    fontSize: 9,
    fontWeight: 400,
    padding: 5,
    minWidth: "40%",
  },

  padding: {
    fontFamily: "Roboto",
    fontWeight: 300,
    fontSize: 11,
    marginBottom: 0,
    paddingLeft: 6,
  },

  servicePeriod: {
    width: "45%",
    marginTop: 12,
  },

  servicePeriodHeader: {
    backgroundColor: "#057AC1",
    padding: 3,
    paddingLeft: 6,
    color: "white",
  },

  servicePeriodTitle: {
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 500,
  },

  servicePeriodBody: {
    flexDirection: "row",
    borderBottom: "1px dotted #838181",
  },

  servicePeriodColumn: {
    width: "50%",
    borderRight: "1px dotted black",
    padding: 5,
  },

  servicePeriodLabel: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: 10,
    color: "#094C75",
    marginBottom: 2,
  },

  servicePeriodValue: {
    fontFamily: "Roboto",
    fontWeight: 300,
    fontSize: 11,
  },

  main: {
    marginTop: 18,
  },

  mainRow: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#057AC1",
    padding: 3,
    paddingLeft: 6,
    color: "white",
    width: "100%",
  },

  desc: {
    width: "40%",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 500,
  },

  datesection: {
    width: "30%",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 500,
  },

  qty: {
    width: "30%",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 500,
  },

  unit: {
    width: "15%",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 500,
  },

  amount: {
    width: "15%",
  },

  amountHeader: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: 11,
  },
  mainDataRow: {
    width: "100%",
    flexDirection: "row",
  },

  complementaryServiceLabel: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: 9,
    color: "#094C75",
    marginBottom: 2,
  },

  complementaryServiceValue: {
    fontFamily: "Roboto",
    fontWeight: 300,
    fontSize: 10,
  },

  borderRightTop: {
    borderRight: "1px dotted black",
    borderBottom: "1px dotted #838181",
    fontFamily: "Roboto",
    fontWeight: 300,
    fontSize: 11,
    paddingLeft: 6,
  },

  invoiceAmount: {
    flexDirection: "row",
    width: "100%",
  },

  blank: {
    width: "65%",
  },

  summaryTitle: {
    width: "25%",
    padding: 7, // Slightly increased padding
    backgroundColor: "#7ABAE0",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 400,
  },

  summaryValue: {
    width: "30%",
    padding: 7, // Slightly increased padding
    backgroundColor: "#7CC7F3",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 400,
  },

  total: {
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: 500,
    color: "#094C75",
  },

  balance: {
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: 500,
    color: "red",
  },

  totalVal: {
    fontFamily: "NotoSans",
    fontSize: 13,
    fontWeight: 500,
  },

  contact: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 15,
    justifyContent: "space-between",
    fontFamily: "Roboto",
    fontSize: 11,
    fontWeight: 400,
  },

  details: {
    fontWeight: 500,
  },

  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  footerText: {
    fontFamily: "Roboto",
    fontSize: 11,
    marginBottom: 5,
  },

  socialMedia: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 12,
  },

  icon: {
    width: 12,
    height: 12,
    marginRight: 3,
  },

  socialIcon: {
    width: 12,
    height: 12,
    marginRight: 3,
  },

  username: {
    fontFamily: "Roboto",
    fontSize: 11,
    marginLeft: 1,
  },

  termsText2: {
    fontSize: 10,
  },
  terms_conditions: {
    width: "100%",
  },
});

export default styles;

export const terms_conditions_styles = {
  ul: {
    listStylePosition: "inside",
    paddingLeft: 12,
    marginVertical: 2,
    fontSize: 12,
    whiteSpace: "normal",
    wordWrap: "break-word",
    color: "#13376b",
  },
  ol: {
    listStylePosition: "inside",
    paddingLeft: 12,
    marginVertical: 2,
    fontSize: 12,
    whiteSpace: "normal",
    wordWrap: "break-word",
    color: "#13376b",
  },
  h1: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#13376b",
  },
  h2: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 4,
    color: "#13376b",
  },
  p: {
    fontSize: 12,
    marginVertical: 4,
    whiteSpace: "normal",
    wordWrap: "break-word",
    color: "#13376b",
  },
  italic: {
    fontStyle: "italic",
  },
  bold: {
    fontWeight: 700,
  },
  boldItalic: {
    fontWeight: 700,
    fontStyle: "italic",
  },
};

export const dietNotes = {
  para: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
    color: "#13376b",
    width: "100%",
  },
};
